import React, { useState, useEffect } from "react";
import { MdEdit } from "react-icons/md";
import { toast } from "react-toastify";
import { adminApiService } from "services/api";

const CustomProductGrid = () => {
  const [gridName, setGridName] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedGrid, setSelectedGrid] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
  });

  const fetchGrids = async () => {
    setIsLoading(true);
    try {
      const response = await adminApiService.getCustomProductGrid();

      if (!response.ok) throw new Error("Failed to fetch product grids");
      const data = await response.json();
      setGridName(data);
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Error fetching product grids");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchGrids();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await adminApiService.updateCustomProductGrid(
        selectedGrid.id,
        formData
      );

      if (!response.ok) throw new Error("Failed to update product grid");

      toast.success("Product grid updated successfully");
      setShowEditModal(false);
      setFormData({ name: "" });
      fetchGrids();
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Error updating product grid");
    }
  };

  const handleEdit = (grid) => {
    setSelectedGrid(grid);
    setFormData({ name: grid.name });
    setShowEditModal(true);
  };

  return (
    <div className="space-y-6 p-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          Custom Product Grid Name
        </h1>
      </div>

      {/* Grids List */}
      <div className="rounded-lg bg-white p-6 shadow-sm">
        {isLoading ? (
          <div className="flex items-center justify-center py-8">
            <div className="border-t-transparent h-8 w-8 animate-spin rounded-full border-4 border-primary"></div>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full table-auto border-collapse">
              <thead>
                <tr className="bg-gray-50 text-left">
                  <th className="whitespace-nowrap rounded-tl-lg px-6 py-3 text-xs font-medium uppercase text-gray-700">
                    Grid Name
                  </th>
                  <th className="whitespace-nowrap rounded-tr-lg px-6 py-3 text-xs font-medium uppercase text-gray-700">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {gridName.map((grid) => (
                  <tr key={grid.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4">
                      <span className="font-medium text-gray-900">
                        {grid.name}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <button
                          onClick={() => handleEdit(grid)}
                          className="rounded-md bg-primary/10 p-2 text-primary transition hover:bg-primary/20"
                        >
                          <MdEdit className="h-5 w-5" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Edit Modal */}
      {showEditModal && (
        <div className="bg-black/50 fixed inset-0 z-50 flex items-center justify-center">
          <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-xl">
            <h2 className="mb-4 text-xl font-bold text-gray-900">
              Edit Product Grid
            </h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label
                  htmlFor="name"
                  className="mb-2 block text-sm font-medium text-gray-700"
                >
                  Grid Name
                </label>
                <input
                  type="text"
                  id="name"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  className="w-full rounded-md border border-gray-300 px-4 py-2 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
                  required
                />
              </div>
              <div className="flex justify-end gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setShowEditModal(false);
                    setFormData({ name: "" });
                  }}
                  className="rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-white transition hover:bg-primary/90"
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomProductGrid;
